import React from 'react';
import { Row, Col } from 'reactstrap';

import excel from '../../../assets/img/icons/ICON62.png';
import calves from '../../../assets/img/icons/ICON13.png';
import Breadcrumbs from '../../layout/breadcrumbs';

import './events.css';




const EventsCalving = props => {
  const breadcrumbs = [{ title: 'Събития', href: '/events' }, { title: 'Раждания и отелвания' }];
  return (
    <div className="container-fluid">
      <Breadcrumbs pathLinks={breadcrumbs} />
      <Row>
        <Col lg="2" className="mb-5">
          <a href="/" className="nav-card">
            <figure><img src={excel} alt="link-icon" /></figure>
            <p className="nav-card-title">
              ИМПОРТ ОТЕЛВАНИЯ И РАЖДАНИЯ
            </p>
          </a>
        </Col>
        <Col lg="2" className="mb-5">
          <a href="/" className="nav-card">
            <figure><img src={calves} alt="link-icon" /></figure>
            <p className="nav-card-title">
              ГРУПОВО <br /> ОТЕЛВАНЕ
            </p>
          </a>
        </Col>
        <Col lg="2" className="mb-5">
          <a href="/" className="nav-card">
            <figure><img src={calves} alt="link-icon" /></figure>
            <p className="nav-card-title">
              РАЖДАНИЯ <br /> ГРУПОВО РАЖДАНЕ
            </p>
          </a>
        </Col>
      </Row>
    </div>
  );
}

export default EventsCalving;